import { prop } from 'ramda';
import { useMemo } from 'react';
import { useDeviceSelector } from 'js/store/hooks';
import { INTEGRATIONS } from '../constants';
import { htcmdService } from 'js/services/htcmd.service';

export const useSelectedIntegration = ({ enableSolus, enableDesktop, enableMobile, enableNative }) => {
    const formFactor = useDeviceSelector(prop('formFactor'));
    const isDesktop = formFactor === 'desktop';

    return useMemo(() => {
        if (enableNative && htcmdService.isWrapperEnabled) {
            return INTEGRATIONS.GEOCOMPLY_NATIVE;
        }

        // Solus covers both Desktop and Mobile if enabled
        if (enableSolus) {
            return INTEGRATIONS.GEOCOMPLY_SOLUS;
        }

        if (enableDesktop && isDesktop) {
            return INTEGRATIONS.GEOCOMPLY_DESKTOP;
        }

        if (enableMobile && !isDesktop) {
            return INTEGRATIONS.GEOCOMPLY_OOBEE;
        }

        return INTEGRATIONS.DISABLED;
    }, [
        enableSolus,
        enableDesktop,
        enableMobile,
        enableNative,
        isDesktop
    ]);
};
